<template>
  <div>
    <FDBannerImg />
    <div class="navigation">
      <div class="page-cen">
        <div class="navigation-item">
          <a href="javascript:void(0)" @click="goPage('/home')">首页</a>&nbsp;&gt;
          <a href="javascript:void(0)" @click="goPage('/comPage/'+ curMenu?.id)" >{{curMenu?.name}}</a>&nbsp;&gt;
          <a class="active" href="javascript:void(0)">详情</a>
        </div>
      </div>
    </div>
    <div class="containerBox">
      <div class="container">
        <div class="leftBox">
          <div class="news_title">{{ data.title }}</div>
          <div id="content"></div>
          <div v-if="!data.info" class="empty">
            <el-empty description="暂无详情"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import FDBannerImg from "@c//FDBannerImg";
import { post, get } from "@u/request";

export default {
  name: "",
  components: { Pagination,FDBannerImg },
  data() {
    return {
      copyright: {},
      data: {},
      dataList: [],
      curMenu:{}
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    pid() {
      return this.$route.params.pid;
    },
    // 缓存页面name
    catche() {
      return this.$store.getters.includeArr;
    },
    key() {
      return this.$router.fullPath;
    },
  },
  methods: {
    async getDetail() {
      const { data } = await get(`lib/content/${this.id}`);
      this.data = data;
      var content = document.getElementById("content");
      content.innerHTML = data.info;
    },
    toDetail(item) {
      this.$router.push(`/news/detail/${item.id}`);
      location.reload();
    },
    async loadList() {
      const params = {
        status: 1,
        pageNum: 1,
        pageSize: 6,
        menuId: 10023,
      };
      if (this.tag !== "全部") {
        params.keyword = this.tag;
      }
      const { rows, total } = await get(
        "lib/content/list",
        params
      ).catch(() => {});
      this.dataList = rows;
      this.total = total;
    },
    goPage(url) {
      this.$router.push(url);
    },
  },
  created() {
    const  id = this.pid?parseInt(this.pid):this.pid;
    const  menuList = sessionStorage.getItem('menuList') ? JSON.parse(sessionStorage.getItem('menuList')) : [];
    const  curMenu = menuList.find(item=>item.id === id);
    this.curMenu = curMenu;
    this.loadList();
    this.getDetail();
  },
};
</script>

<style scoped lang="scss">
.containerBox {
  width: 100%;
  background-color: #f8f8f8;
  .container {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 96px;
    .leftBox {
      width: 100%;
      background-color: #fff;
      padding: 0 20px 50px;
      .news_title {
        font-size: 18px;
        line-height: 40px;
        padding-bottom: 20px;
        padding-top: 30px;
        text-align: center;
        color: #004796;
        font-weight: 700;
      }
      #content {
        font-size: 14px;
        color: #666;
        line-height: 24px;
      }
    }
    .rightBox {
      padding-left: 60px;
      padding-top: 0px;
      width: 35%;
      .titleBox {
        display: flex;
        .title_icon {
          padding: 0;
          width: 40px;
          height: 40px;
          line-height: 35px;
          text-align: center;
          background: #004796;
          box-shadow: 2px 2px 9px rgba(0, 0, 0, 0.6);
        }
        .title {
          margin-left: 20px;
          font-size: 18px;
          line-height: 40px;
          color: #004796;
        }
      }
      .listBox {
        margin-top: 20px;
        .list_item {
          cursor: pointer;
          padding: 14px 0;
          border-bottom: 1px dashed #999;
          font-size: 14px;

          .date {
            img {
              transform: translateY(-1px);
              margin-right: 10px;
            }
            font-size: 12px;
            color: #999;
            margin-bottom: 6px;
          }
        }
        .list_item:first-child {
          border-top: 1px dashed #999;
        }
        .more {
          padding: 15px 0;
          font-size: 14px;
          line-height: 22px;
          a {
            color: #004796;
          }
        }
      }
    }
  }
}
</style>
